export class CustomerLocationDTOModel {
    public id: number;
    public description: string;

    [x: string]: any;
}
